import { getAuthAxiosBackend } from "@/helpers/axios"

class EducationalInstitutionsServices {
    get(id) {
        return getAuthAxiosBackend().get('EducationalInstitutions/getEducationalInstitutionsById/' + id.toString())
    }

    getAll(data = {}) {
        return getAuthAxiosBackend().get('EducationalInstitutions/all', { params: data })
    }

    add(data) {
        return getAuthAxiosBackend().post('EducationalInstitutions/addEducationalInstitutions', data)
    }

    edit(id, data) {
        return getAuthAxiosBackend().put('EducationalInstitutions/updateEducationalInstitutions/' + id, data)
    }

    restore(id, data) {
        return getAuthAxiosBackend().put('EducationalInstitutions/restoreEducationalInstitutions' + id, data)
    }

    delete(id) {
        return getAuthAxiosBackend().delete('EducationalInstitutions/softDeleteEducationalInstitutions/' + id.toString())
    }

    forceDelete(id) {
        return getAuthAxiosBackend().delete('EducationalInstitutions/deleteEducationalInstitutions/' + id.toString())
    }
}

export default new EducationalInstitutionsServices()
